import type { Vendor } from '../../webrtc/media';
import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import { type PostCallSurveyCallType } from './postCallSurveyCallType';

/**
 * Data from the call to submit with the survey.
 */
export type SurveyCallDetails = {
  dbSessionId: string;
  sessionId: string;
  noSoundDetected: boolean;
  vendor: Vendor;
  callType: PostCallSurveyCallType;
};

type PostCallSurveySliceState = {
  /**
   * If not defined, then do not show the survey.
   */
  details?: SurveyCallDetails;
};

const initialState: PostCallSurveySliceState = {};

export const postCallSurveySlice = createSlice({
  name: 'postCallSurvey',
  initialState,
  reducers: {
    /**
     * When a call ends, dispatch this action to make the post-call survey appear after the call.
     * The payload data are required for the survey and submitted alongside values.
     */
    setupPostCallSurvey(state, action: PayloadAction<SurveyCallDetails>) {
      state.details = action.payload;
    },

    /**
     * Once a call lifecycle is fully completed, reset state for the next call.
     */
    resetPostCallSurvey(state) {
      delete state.details;
    },
  },
});

export const { setupPostCallSurvey, resetPostCallSurvey } =
  postCallSurveySlice.actions;
